import React, { Component } from 'react';

import icons from './icons';
/**
 * PROPS
 * value = string
 * label = string
 * type = string "white"/"red"
 * onChange(value) = func
 */

export default class Icon extends Component {
  state = {
    opened: false,
  };

  onChooseIcon (i) {
    this.setState({
      opened: false
    });
    this.props.onChange(i)
  }

  render() {
    const icon = this.props.value || 'Alert';

    const iconsBtns = Object.keys(icons).map(i => {
      return (
        <button
          key={i}
          className="icon-selector__item"
          onClick={() => this.onChooseIcon(i)}
        >
          <img src={`/static/img/constructor/icons/red/${i}.svg`} />
        </button>
      );
    });

    return (
      <React.Fragment>
        <div className="icon-selector">
          <button
            onClick={() => this.setState({ opened: !this.state.opened })}
            className="icon-selector__selected"
          >
            <img src={`/static/img/constructor/icons/red/${icon}.svg`} />
            <span>{icons[icon] ? icons[icon] : 'Иконка не найдена'}</span>
          </button>
          <div className={`icon-selector__dropdown ${this.state.opened ? 'is-opened' : null}`}>
            <div className="wrap">{iconsBtns}</div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
